import React from 'react';
import { IProps } from './type';

const InfoIcon = ({ cName, width, height, fillColor, strokeColor, viewBox, onClick }: IProps) => {
  return (
    <svg
      className={cName}
      width={width ? width : '20'}
      height={height ? height : '20'}
      viewBox={viewBox ? viewBox : '0 0 20 20'}
      fill={fillColor ? fillColor : 'none'}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg">
      <circle cx="10" cy="10" r="7"
        stroke={strokeColor ? strokeColor : "#21242A"}
        strokeOpacity="0.48" />
      <path
        d="M10 14V8"
        stroke={strokeColor ? strokeColor : "#21242A"}
        strokeOpacity="0.48" />
      <path d="M10.4167 6.41667C10.4167 6.64679 10.2301 6.83333 10 6.83333C9.76989 6.83333 9.58334 6.64679 9.58334 6.41667C9.58334 6.18655 9.76989 6 10 6C10.2301 6 10.4167 6.18655 10.4167 6.41667Z"
        fill={fillColor ? fillColor : "#21242A"}
        fillOpacity="0.48" />
    </svg>
  )
};

export default InfoIcon;
